<template>
  <div
    class="back-to-top"
    :class="isVisible ? 'visible' : ''"
    @click="scrollToTop"
  >
    <q-icon name="fa-solid fa-chevron-up" />
  </div>
</template>

<script setup lang="ts">
import { throttle } from "lodash";
import { onMounted, onUnmounted, ref } from "vue";

const isVisible = ref(false);

const scrollToTop = () => {
  if (scrollableContentElement === null) {
    return;
  }

  scrollableContentElement.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

let scrollableContentElement: HTMLElement | null = null;

const handleScroll = throttle(() => {
  if (scrollableContentElement === null) {
    return;
  }

  isVisible.value = scrollableContentElement.scrollTop > 1000;
}, 200);

onMounted(() => {
  scrollableContentElement = document.getElementById("scrollable-content");

  if (scrollableContentElement === null) {
    return;
  }

  scrollableContentElement.addEventListener("scroll", handleScroll);
  handleScroll();
});

onUnmounted(() => {
  if (scrollableContentElement !== null) {
    scrollableContentElement.removeEventListener("scroll", handleScroll);
  }
});
</script>

<style lang="scss">
.back-to-top {
  @apply tw-pointer-events-none tw-fixed tw-bottom-[16px] tw-right-4 tw-z-[999] tw-flex tw-h-[48px] tw-w-[48px] tw-translate-y-[10px] tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-[#ccc] tw-bg-[#1a2744] tw-text-white tw-opacity-0 tw-transition-all hover:!tw-opacity-[90%] sm:tw-right-8 md:tw-p-4;
  transition: all 0.2s ease-in-out;

  &.visible {
    @apply tw-pointer-events-auto tw-translate-y-0 tw-opacity-100;
  }
}
</style>
